import React from "react"
import { createStackNavigator } from "@react-navigation/stack"
import {
  EditProfileScreen,
  PointHistoryScreen,
  ProfileScreen,
  ReferralScreen,
  VoucherDetailScreen,
  VoucherScreen,
} from "screens"
import { translate } from "i18n"
import { Header } from "components"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"
import { EditPinScreen } from "screens/Application/EditPin"
import { NotificationScreen } from "screens/Application/Notification"
import { FeedbackScreen } from "screens/Application/Feedback"

export type ProifleParamList = {
  profile: undefined
  voucher: undefined
  voucherDetail: undefined
  editProfile: undefined
  pointHistory: undefined
  editPin: undefined
  notification: undefined
  feedback: undefined
  referral: undefined
}
const Stack = createStackNavigator<ProifleParamList>()

export const ProfileStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        header: (props) => {
          return <Header {...props} />
        },
        headerBackImage: () => <MaterialIcons name="chevron-left" color="white" size={42} />,
        headerBackTitleVisible: false,
        headerTitleAlign: "left",
        headerStyle: {
          backgroundColor: "transparent",
          borderBottomWidth: 0,
        },
        headerTintColor: "white",
        cardStyle: { flex: 1 },
      }}
    >
      <Stack.Screen
        name="profile"
        component={ProfileScreen}
        options={{
          headerTitle: translate("profileScreen.title"),
        }}
      />
      <Stack.Screen
        name="voucher"
        component={VoucherScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="voucherDetail"
        component={VoucherDetailScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="notification"
        component={NotificationScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="feedback"
        component={FeedbackScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="editProfile"
        component={EditProfileScreen}
        options={{
          headerTitle: translate("editProfileScreen.title"),
        }}
      />
      <Stack.Screen
        name="editPin"
        component={EditPinScreen}
        options={{
          headerTitle: translate("editNewPinScreen.title"),
        }}
      />
      <Stack.Screen
        name="pointHistory"
        component={PointHistoryScreen}
        options={{
          headerTitle: translate("pointHistoryScreen.title"),
        }}
      />
      <Stack.Screen
        name="referral"
        component={ReferralScreen}
        options={{
          headerTitle: translate("pointHistoryScreen.title"),
        }}
      />
    </Stack.Navigator>
  )
}
